import type { AuthenticatedUser } from "../../api/auth";
import { TenantContainer } from "../TenantContainer";
import { CheckinPage } from "./CheckinPage";
import { HardwareMonitorPage } from "../intecio-gmbh/HardwareMonitorPage";
import type { LaunchpadTile } from "../../components/Launchpad";

interface TenantRootProps {
  currentUser?: AuthenticatedUser;
}

// IntecIO GmbH Launchpad Tiles
const TENANT_TILES: LaunchpadTile[] = [
  {
    id: "hardware-monitor",
    title: "Hardware Monitor",
    description: "Überwachung aller Hardware-Geräte",
    icon: "🖥️",
    path: "/hardware-monitor",
  },
  {
    id: "checkin",
    title: "Check-in",
    description: "Fahrzeug Check-in System",
    icon: "📋",
    path: "/checkin",
  }
];

// IntecIO GmbH Tenant Routes
const TENANT_ROUTES = [
  {
    path: "/checkin",
    element: <CheckinPage />
  },
  {
    path: "/hardware-monitor",
    element: <HardwareMonitorPage />
  }
];

export function TenantRoot({ currentUser }: TenantRootProps) {
  return (
    <TenantContainer
      tiles={TENANT_TILES}
      routes={TENANT_ROUTES}
      currentUser={currentUser}
    />
  );
}

export { CheckinPage };
